<template>
  <div class="wrapper">
    <div class="check-titleBlock">
      <h1 class="check-titleBlock__title">Мои чеки</h1>
      <div class="check-title__counter">чеков: {{ checkList.length }}</div>
    </div>
    <div
      class="check-container"
      v-for="check in checkList"
      :key="check.id"
      @click="$router.push({ name: 'LcSingle', params: { id: check.id } }).catch(() => {})"
    >
      <div class="check__date">
        {{ getDate(check.create_date) }}
      </div>
      <div
        class="check__status"
        :class="{
          verified: check.status === 'verified',
          wait: check.status === 'wait',
          notVerified: check.status === 'notVerified',
          onHold: check.status === 'onHold',
        }"
      >
        {{ statuses[check.status] }}
      </div>
      <div
        v-if="check.status !== 'wait' && ['success', 'error'].includes(check.payment_status)"
        class="payment__status"
        :class="{
          paymentMade: check.payment_status === 'success',
          paymentError: check.payment_status === 'error',
        }"
      >
        {{ paymentStatuses[check.payment_status] }}
      </div>
      <div class="check__arrow"></div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    checkList: { type: Array, required: true },
  },
  data() {
    return {
      statuses: {
        wait: "Проверка",
        verified: "Принято",
        notVerified: "Отклонено",
        onHold: "На ожидании",
      },
      paymentStatuses: {
        success: "Выплачено",
        error: "Ошибка выплаты",
      },
    };
  },
  methods: {
    getDate(fullDate) {
      return moment(fullDate).utc().local().format("DD.MM.YYYY HH:mm");
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  margin-bottom: 20px !important;
  margin-top: 0 !important;
  padding: 0 !important;
  gap: 0px !important;
}
.check-titleBlock {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
}
.check-titleBlock__title {
  font-family: "PT Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 100%;
  text-align: center;
  letter-spacing: -0.005em;
  color: black;
}
.check-title__counter {
  min-width: 107px;
  min-height: 26px;
  text-align: center;
  background: var(--main-color);
  border-radius: 8px;
}
.check-title__counter {
  font-family: "PT Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 130%;
  letter-spacing: -0.005em;
  color: var(--white-color);
  display: flex;
  align-items: center;
  justify-content: center;
}
.check-container {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 44px;
  background: var(--card-color);
  border-radius: 8px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: -0.015em;
  color: #1a1a1a;
  margin-bottom: 12px;
  padding: 15px 10px;
  cursor: pointer;
}
.check__date {
  text-align: start;
  width: 34%;
  min-width: 110px;
  padding-right: 5px;
  color: var(--text-color);

  @media (min-width: 1440px) {
    width: 50%;
    min-width: 200px;
    font-size: 16px;
    padding-right: 20px;
  }

  @media (max-width: 768px) {
    width: 60%;
    font-size: 12px;
    margin-right: 0;
  }

  @media (max-width: 320px) {
    width: 40%;
    min-width: auto;
    font-size: 10px;
  }
}
.check__status,
.payment__status {
  display: flex;
  justify-content: center;
  font-size: 12px;
  background: #f5dfcc;
  border-radius: 8px;
  min-height: 24px;
  align-items: center;
  width: 30%;
  padding: 5px 10px;
  width: 100px;
  margin-right: 10px;

  @media (max-width: 320px) {
    width: calc(50% - 4px);
    font-size: 10px;
    margin-right: 2px;
  }

  @media (max-width: 768px) {
    font-size: 10px;
    margin-right: 5px;
  }

  @media (min-width: 769px) {
    font-size: 12px;
    margin-right: 10px;
  }
}

.payment__status {
  white-space: nowrap;
  background: #b8b8b8;
  width: 130px;
  margin-right: 2px;

  @media (max-width: 320px) {
    width: calc(60% - 4px);
    font-size: 10px;
    padding: 4px 8px;
    margin-right: 5px;
  }

  @media (max-width: 768px) {
    font-size: 10px;
    margin-right: 0;
  }

  @media (min-width: 769px) {
    font-size: 12px;
  }
}

.check__status.wait {
  background: #b8b8b8;
}
.check__status.verified,
.payment__status.paymentMade {
  background: #deecdc;
}
.check__status.notVerified,
.payment__status.paymentError {
  background: #fae3de;
}
.check__status.onHold {
  background: #7a96e3;
}
.check__arrow {
  position: absolute;
  right: 12px;
  min-width: 10px;
  height: 10px;
  background-image: url("../assets/arrow.svg");

  @media (max-width: 767px) {
    display: none;
  }
  @media (min-width: 769px) {
    right: 15px;
    min-width: 12px;
    height: 12px;
    display: block;
  }
}

@media screen and (max-width: 4000px) and (min-width: 769px) {
  .check-titleBlock h1 {
    font: 700 40px "PT Sans";
    line-height: 110%; /* 44px */
    letter-spacing: -0.2px;
  }
}
</style>
